// extracted by mini-css-extract-plugin
export var cardLayout = "_72-1";
export var paginationContainer = "_72-0";